export const apiMethods = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  PATCH: 'patch',
  DELETE: 'delete',
} as const;

export type ApiMethod = (typeof apiMethods)[keyof typeof apiMethods];

export const SECURE_USER_GROUPS_KEY = 'groups';
